<template>
    <div>
        <label v-if="id" :for="id" class="symbol-label" v-bind:class="{validator:show_validation && isNaN(value)}">{{label}}</label>
        <div class="number-input-wrap" @mouseenter="disableDrag" @mouseleave="enableDrag">
            <vue-numeric currency="$" separator="," :minus="false" :precision="2"
                         v-model="internalV" :placeholder="placeholder" class="form-control"
                          autofocus @mousedown.stop=""

            ></vue-numeric>
            <div class="number-nav">
                <div class="number-button number-up" @click.stop="inc()">&and;</div>
                <div class="number-button number-down" @click.stop="dec()">&or;</div>
            </div>
        </div>

    </div>

</template>

<script>

    import Component from 'vue-class-component'
    import {Prop, Watch, Vue, Emit} from 'vue-property-decorator'
    import VueNumeric from 'vue-numeric'
    import {EventBus,Messages} from '../../services/EventBus';

    export default Vue.extend ({
        name:'CurrencyInput',
        components:{VueNumeric},
        computed:{
          internalV: {
              get(){return this.value},
              set(v){this.$emit('input', v)}
          }
        },
        mounted(){
            this.$children[0].$el.autofocus = true;
            this.$children[0].$el.focus();
        },
        props:{
            value: {type:Number, required:false, default:0},
            label:{type:String,required:true},
            id:{type:String,required:false, default:""},
            focus:{type:Boolean, required:false,default:false},
            show_validation:  {type:Boolean,required:true},
            placeholder: {type:String,required:false,default:'Price'}
        } , methods: {
            disableDrag(){
                EventBus.$emit(Messages.DragPlaceWindowDisable)
            },
            enableDrag(){
                EventBus.$emit(Messages.DragPlaceWindowEnable)
            },
            setNum(v) {
                this.$nextTick(()=>{

                    this.$emit('input', v);
                });
            },
            inc(){
                this.internalV+=0.01;
            },
            dec(){
                if (this.internalV>=0.01) this.internalV-=0.01;
            }
        },data(){
            return {
                money: {
                    decimal: ',',
                    thousands: '.',
                    prefix: '$',
                    suffix: '',
                    precision: 2,
                    masked: false
                }
            }
        }
//          focus:{
//              get(){
//                  return this.focus;
//              },
//              set(){
//                  this.$emit('focus')
//              }
//          }
//        }
    })
 </script>

<style scoped>

</style>